import { Box, Button, Paper } from "@material-ui/core"
import ArrowBack from "@material-ui/icons/ArrowBack"
import ExpandMore from "@material-ui/icons/ExpandMore"
import { useMemo } from "react"
import type { ReactElement } from "react"

import { useTranslation } from "react-i18next"
import { Body1 } from "../../atoms"

import "./fullscreen-dialog-footer.styles.scss"

export interface IFullscreenDialogFooterProps {
  activeStep: number
  confirmText: string
  confirmDisabled: boolean
  selectorProps?: {
    count: number
    text: string
    selectorOpen: boolean
    onClick: () => void
  }
  onBackClicked: () => void
  onConfirmStep: () => void
}

export function FullscreenDialogFooter(props: IFullscreenDialogFooterProps): ReactElement {
  const { activeStep, confirmText, confirmDisabled, selectorProps, onBackClicked, onConfirmStep } = props
  const { t } = useTranslation("general")

  const { count, text, selectorOpen } = useMemo<{
    count: number
    text: string
    selectorOpen: boolean
  }>(() => {
    if (selectorProps) {
      return { ...selectorProps }
    }
    return { count: 0, text: "", selectorOpen: false }
  }, [selectorProps])

  function handleSelectorOnClick(): void {
    selectorProps?.onClick()
  }

  return (
    <Paper square elevation={3} className="fullscreen-dialog-footer">
      <Button
        variant="outlined"
        color="primary"
        onClick={onBackClicked}
        disabled={activeStep === 0}
        className="back-button"
      >
        <ArrowBack />
        {t("previousStep")}
      </Button>

      {selectorProps && (
        <Box className="fullscreen-dialog-footer-selection" onClick={handleSelectorOnClick}>
          <Body1 className="selection">
            {count} {text}
          </Body1>
          <ExpandMore className={`arrow ${selectorOpen ? "" : "expanded"}`} />
        </Box>
      )}
      <Button
        className="next-button"
        onClick={onConfirmStep}
        disabled={confirmDisabled}
        variant="contained"
        color="primary"
      >
        {confirmText}
      </Button>
    </Paper>
  )
}
